import { render, staticRenderFns } from "./IntegrationReturn.vue?vue&type=template&id=b8b18700&scoped=true&"
import script from "./IntegrationReturn.vue?vue&type=script&lang=js&"
export * from "./IntegrationReturn.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationReturn.vue?vue&type=style&index=0&id=b8b18700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b18700",
  null
  
)

export default component.exports